import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import general components
import BaseTitle from "../../../common/base-title/base-title";

//import view components
import FlightItem from "./flight-item";
import DayChange from "../../../common/day-change/day-change";

//import styles
import "./flight-list.scss";

function FlightList({ flightData, flightList, setRequestFlag, setUid, resetFilters }) {
    //general variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);

    //sessionStorage variables
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation"));
    const isTwoWay = domesticFlightInformation?.returnDate;

    // Memoize the full flight lists for departure and return
    const { fullFlightListData } = useMemo(
        () => ({
            fullFlightListData: flightData?.data?.full,
        }),
        [flightData],
    );

    //display fligth list
    const [fullFlightList, setFullFlightList] = useState([]);
    useEffect(() => {
        setFullFlightList(fullFlightListData);
    }, [fullFlightListData]);

    return (
        <Grid container item xs={12} rowGap={2} justifyContent="center" alignItems="flex-start">
            <BaseTitle
                title={`${t("flightList")}:`}
                dividerColor="1px solid var(--medium-gray-color)"
                button={
                    !isTwoWay && (
                        <DayChange
                            label="domesticFlightInformation"
                            information={domesticFlightInformation}
                            date={flightList?.[0]?.departure_date}
                            isDeparture={!isTwoWay}
                            setRequestFlag={setRequestFlag}
                            setUid={setUid}
                        />
                    )
                }
            />

            {flightList?.map((flightItem, index) => {
                return (
                    <Grid className="flight-list" key={index} container item xs={12} rowGap={2}>
                        <FlightItem flightItem={flightItem} isFull={false} />
                    </Grid>
                );
            })}

            {fullFlightList?.length ? (
                <Grid container item xs={12} rowGap={2} mt={5}>
                    <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                        <Grid className="flight-list__title" component="span" container item xs="auto">
                            {t("fullFlight")}:
                        </Grid>
                        <Divider sx={{ width: { xs: "50%", md: "85%" } }} />
                    </Grid>
                    {fullFlightList?.map((flightItem, index) => {
                        return (
                            <Grid key={index} container item xs={12}>
                                <FlightItem flightItem={flightItem} isFull={true} />
                            </Grid>
                        );
                    })}
                </Grid>
            ) : null}
        </Grid>
    );
}

function mapStateToProps(state) {
    return {
        flightData: state.flightData,
    };
}

export default connect(mapStateToProps)(FlightList);
